import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'

export const baseManage = {
  path: '/baseManage/',
  name: 'baseManage',
  component: LayoutWithSideMenu,
  meta: {
    title: '基础管理'
  },
  children: [{
    path: 'project',
    name: 'project',
    component: () => import('@/views/baseManage/projectManagement/project/index.vue'),
    meta: {
      title: '项目管理'
    }
  }, {
    path: 'vehicleManagement',
    name: 'vehicleManagement',
    component: () => import('@/views/baseManage/vehicleManagement/index.vue'),
    meta: {
      title: '列车管理'
    }
  }, {
    path: 'trainKmIndex',
    name: 'trainKmIndex',
    component: () => import('@/views/baseManage/vehicleManagement/trainKmIndex.vue'),
    meta: {
      title: '列车里程管理'
    }
  }, {
    path: 'vehicleStructureTree',
    name: 'vehicleStructureTree',
    component: () => import('@/views/baseManage/vehicleStructureTree/index.vue'),
    meta: {
      title: '车辆结构树'
    }
  }, {
    path: 'afterSaleStation',
    name: 'afterSaleStation',
    component: () => import('@/views/baseManage/afterSaleStation/index.vue'),
    meta: {
      title: '站点管理'
    }
  }

  ]
}
